module.exports = __webpack_public_path__ + "static/media/p2.9c9d3ab7.jpg";